export const MY_PROFILE = `MY_PROFILE`;

export const GET_E_CARD_INFO = `${MY_PROFILE}/GET_E_CARD_INFO`;
export const SET_E_CARD_INFO = `${MY_PROFILE}/SET_E_CARD_INFO`;

export const GET_E_CARD_PERSONAL_BUSINESS_INFO = `${MY_PROFILE}/GET_E_CARD_PERSONAL_BUSINESS_INFO`;
export const SET_E_CARD_PERSONAL_BUSINESS_INFO = `${MY_PROFILE}/SET_E_CARD_PERSONAL_BUSINESS_INFO`;

export const GET_E_CARD_AVATAR = `${MY_PROFILE}/GET_E_CARD_AVATAR`;
export const SET_E_CARD_AVATAR = `${MY_PROFILE}/SET_E_CARD_AVATAR`;

export const GET_E_CARD_QR_IMAGE = `${MY_PROFILE}/GET_E_CARD_QR_IMAGE`;
export const SET_E_CARD_QR_IMAGE = `${MY_PROFILE}/SET_E_CARD_QR_IMAGE`;

export const GET_AGENT_REQUEST_VALIDATE_CHANGE_AVA = `${MY_PROFILE}/GET_AGENT_REQUEST_VALIDATE_CHANGE_AVA`;

export const GET_AGENT_REQUEST_GENERATE_OTP_FOR_CHANGE_AVA = `${MY_PROFILE}/GET_AGENT_REQUEST_GENERATE_OTP_FOR_CHANGE_AVA`;
export const GET_REFRESH_OTP = `${MY_PROFILE}/GET_REFRESH_OTP`;

export const GET_AGENT_REQUEST_VALIDATE_OTP = `${MY_PROFILE}/GET_AGENT_REQUEST_VALIDATE_OTP`;
export const SET_AGENT_REQUEST_VALIDATE_OTP = `${MY_PROFILE}/SET_AGENT_REQUEST_VALIDATE_OTP`;

export const GET_AGENT_REQUEST_NUM_AVA = `${MY_PROFILE}/GET_AGENT_REQUEST_NUM_AVA`;
export const SET_AGENT_REQUEST_NUM_AVA = `${MY_PROFILE}/SET_AGENT_REQUEST_NUM_AVA`;

export const GET_AGENT_REQUEST_PERSONAL_INFO_LIST = `${MY_PROFILE}/GET_AGENT_REQUEST_PERSONAL_INFO_LIST`;
export const SET_AGENT_REQUEST_PERSONAL_INFO_LIST = `${MY_PROFILE}/SET_AGENT_REQUEST_PERSONAL_INFO_LIST`;

export const GET_AGENT_REQUEST_PERSONAL_INFO_DETAILS = `${MY_PROFILE}/GET_AGENT_REQUEST_PERSONAL_INFO_DETAILS`;
export const SET_AGENT_REQUEST_PERSONAL_INFO_DETAILS = `${MY_PROFILE}/SET_AGENT_REQUEST_PERSONAL_INFO_DETAILS`;

export const GET_AGENT_REQUEST_PAYMENT_PLAN = `${MY_PROFILE}/GET_AGENT_REQUEST_PAYMENT_PLAN`;
export const SET_AGENT_REQUEST_PAYMENT_PLAN = `${MY_PROFILE}/SET_AGENT_REQUEST_PAYMENT_PLAN`;

export const GET_AGENT_REQUEST_VALIDATE_CHANGE_PERSONAL_INFO = `${MY_PROFILE}/GET_AGENT_REQUEST_VALIDATE_CHANGE_PERSONAL_INFO`;

export const GET_AGENT_REQUEST_NUM_NEXT_VALUE = `${MY_PROFILE}/GET_AGENT_REQUEST_NUM_NEXT_VALUE`;
export const GET_INFO_REQUEST_FORM = `${MY_PROFILE}/GET_INFO_REQUEST_FORM`;
